























































































































































































import Vue from "vue";
import Component from "vue-class-component";
import {useRentalStore} from "@/store/rental";
import type {RentalRequest} from "@/api/models/rental";
import {RentalRequestStatus, RentalRequestStatusLabels} from "@/api/models/rental";
import dayjs from "dayjs";
import SmbButton from "@/components/ui/SmbButton/SmbButton.vue";
import SmbTextArea from "@/components/ui/SmbTextArea/SmbTextArea.vue";

interface ModalForm {
  status: RentalRequestStatus;
  adminNotes: string;
}

interface StatusOption {
  value: RentalRequestStatus;
  label: string;
  icon: string;
  class: string;
}

@Component({
  components: {
    SmbButton,
    SmbTextArea,
  },
  metaInfo: {
    title: "Leihgerät-Anfragen",
  },
})
export default class RentalRequestsList extends Vue {
  public isLoading = true;
  public isSaving = false;
  public selectedRequest: RentalRequest | null = null;
  public modalForm: ModalForm = {
    status: RentalRequestStatus.Pending,
    adminNotes: "",
  };

  public statusOptions: StatusOption[] = [
    { value: RentalRequestStatus.Pending, label: "Ausstehend", icon: "clock", class: "pending" },
    { value: RentalRequestStatus.Confirmed, label: "Bestätigt", icon: "check", class: "confirmed" },
    { value: RentalRequestStatus.Rejected, label: "Abgelehnt", icon: "times", class: "rejected" },
    { value: RentalRequestStatus.Completed, label: "Abgeschlossen", icon: "check-double", class: "completed" },
  ];

  public get rentalRequests(): RentalRequest[] {
    return useRentalStore().rentalRequests;
  }

  public async mounted(): Promise<void> {
    await this.loadRequests();
  }

  public async loadRequests(): Promise<void> {
    this.isLoading = true;
    try {
      const rentalStore = useRentalStore();
      await rentalStore.fetchRentalRequests(true);
    } catch (e) {
      console.error("Error loading rental requests:", e);
    } finally {
      this.isLoading = false;
    }
  }

  public formatDate(dateString: string): string {
    return dayjs(dateString).format("DD.MM.YYYY");
  }

  public getStatusLabel(status: RentalRequestStatus): string {
    return RentalRequestStatusLabels[status] || "Unbekannt";
  }

  public getStatusClass(status: RentalRequestStatus): string {
    switch (status) {
      case RentalRequestStatus.Pending:
        return "status-pending";
      case RentalRequestStatus.Confirmed:
        return "status-confirmed";
      case RentalRequestStatus.Rejected:
        return "status-rejected";
      case RentalRequestStatus.Completed:
        return "status-completed";
      default:
        return "";
    }
  }

  public getStatusBadgeClass(status: RentalRequestStatus): string {
    switch (status) {
      case RentalRequestStatus.Pending:
        return "badge-pending";
      case RentalRequestStatus.Confirmed:
        return "badge-confirmed";
      case RentalRequestStatus.Rejected:
        return "badge-rejected";
      case RentalRequestStatus.Completed:
        return "badge-completed";
      default:
        return "";
    }
  }

  public truncateMessage(message: string): string {
    if (message.length > 100) {
      return message.substring(0, 100) + "...";
    }
    return message;
  }

  public showDetails(request: RentalRequest): void {
    this.selectedRequest = request;
    this.modalForm = {
      status: request.status,
      adminNotes: request.adminNotes || "",
    };
  }

  public closeModal(): void {
    this.selectedRequest = null;
  }

  public async updateStatus(): Promise<void> {
    if (!this.selectedRequest) return;

    this.isSaving = true;
    try {
      const rentalStore = useRentalStore();
      const result = await rentalStore.updateRequestStatus(
        this.selectedRequest.id,
        this.modalForm.status,
        this.modalForm.adminNotes || null
      );

      if (result.success) {
        this.closeModal();
      } else {
        alert(result.message || "Fehler beim Aktualisieren.");
      }
    } catch (e) {
      console.error("Error updating status:", e);
      alert("Fehler beim Aktualisieren des Status.");
    } finally {
      this.isSaving = false;
    }
  }
}
